export class InitBasketAction {
  static type = '[BASKET] Init';
  constructor(public step: number) {}
}
